import axios from "axios";
import { baseUrl } from "../App";

export const fetchProfileExtraData = async (token) => {
  const res = await axios.get(`${baseUrl}/profileSummeryOneApi/?portal=15`, {
    headers: { Authorization: `Token ${token}` }
  });
  return res.data;
}